import { Pipe, PipeTransform } from '@angular/core';
import { SvgUtils } from '../utils/SvgUtils';
import { IShape } from '../interfaces';
import { ColorUtils } from '@cinetixx/cinetixx-ui';
import { ShapeSeatTypes } from '../enums';
import { ElementTypes } from '../enums/ElementTypes';

@Pipe({
  name: 'svgToBase64Bg',
})
export class SvgToBase64BgPipe implements PipeTransform {

  public transform(shape: IShape, color: string): string {
    let svg: string;

    if (shape.shapeSeatType !== ShapeSeatTypes.NONE) {
      const color2 = ColorUtils.adjustColor(color, 20);
      const color3 = ColorUtils.adjustColor(color, 80);

      if (shape.shapeSeatType === ShapeSeatTypes.SEAT && !shape.loveSeatId) {
        svg = SvgUtils.getNormalFreeSeatSvg(color, color2, color3);
      } else if (shape.shapeSeatType === ShapeSeatTypes.DISABLED) {
        svg = SvgUtils
          .getDisabledFreeSeatSvg(color, color2, color3, ColorUtils.isLightColor(color) ? 'black' : 'white');
      } else if (shape.shapeSeatType === ShapeSeatTypes.SEAT_WITH_FOOTSTOOL) {
        svg = SvgUtils.getSeatWithFootstoolSvg(color, color2, color3);
      } else if (shape.shapeSeatType === ShapeSeatTypes.LOVE_SEAT_LEFT) {
        svg = SvgUtils.getLoveLeftFreeSeatSvg(color, color2, color3);
      } else if (shape.shapeSeatType === ShapeSeatTypes.LOVE_SEAT_RIGHT) {
        svg = SvgUtils.getLoveRightFreeSeatSvg(color, color2, color3);
      } else if (shape.shapeSeatType === ShapeSeatTypes.SEAT && shape.loveSeatId) {
        svg = SvgUtils.getLoveInnerFreeSeatSvg(color, color2, color3);
      }
    } else {
      if (shape.shapeElementType === ElementTypes.SCREEN) {
        svg = SvgUtils.getScreenSvg(color);
      }
    }

    const encoded = encodeURIComponent(svg.trim())
      .replace(/'/g, '%27')
      .replace(/"/g, '%22');

    return `url("data:image/svg+xml,${encoded}")`;
  }
}
